import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function LegalNotice() {
  return (
    <LegalLayout title="Mentions légales" lastUpdate="13 février 2026">
      <h2>1. Éditeur du site</h2>
      <p>Le site <strong>fripri.com</strong> est édité par :</p>
      <ul>
        <li><strong>ECOLOVALO</strong> — Association loi 1901 déclarée</li>
        <li>SIREN : <strong>801 257 593</strong></li>
        <li>Siège social : 5 Boulevard Galliéni, 92390 Villeneuve-la-Garenne, France</li>
        <li>Téléphone : 09 70 70 94 24</li>
        <li>Email : <a href="mailto:contact@fripri.com">contact@fripri.com</a></li>
      </ul>

      <h2>2. Directeur de la publication</h2>
      <p><strong>M. EL ARABI Youssef</strong>, en qualité de Président de l’association ECOLOVALO.</p>

      <h2>3. Hébergement</h2>
      <p>Le site est hébergé par :</p>
      <ul>
        <li><strong>Emergent (Emergent Labs)</strong></li>
        <li>Site web : <a href="https://emergent.sh" target="_blank" rel="noreferrer">emergent.sh</a></li>
      </ul>

      <h2>4. Propriété intellectuelle</h2>
      <p>L’ensemble des contenus présents sur le site fripri.com (textes, images, logos, marques, structure, charte graphique, code source) sont la propriété exclusive d’ECOLOVALO ou de ses partenaires. Toute reproduction, représentation, modification, publication, adaptation ou exploitation, totale ou partielle, par quelque procédé que ce soit, est interdite sans l’autorisation écrite préalable de l’éditeur.</p>
      <p>Les photographies des articles mis en vente restent la propriété des vendeurs qui les publient. En les mettant en ligne, les vendeurs concèdent à ECOLOVALO un droit non exclusif d’utilisation à des fins d’affichage sur Fripri.</p>

      <h2>5. Données personnelles</h2>
      <p>Le traitement des données personnelles est détaillé dans notre <a href="/confidentialite">Politique de confidentialité</a>. Conformément au RGPD, vous disposez d’un droit d’accès, de rectification, d’effacement, de portabilité et d’opposition. Pour exercer ces droits : <a href="mailto:direction@fripri.com">direction@fripri.com</a>.</p>

      <h2>6. Cookies</h2>
      <p>Le site utilise uniquement des cookies essentiels (authentification, panier). Voir la <a href="/cookies">Politique cookies</a>.</p>

      <h2>7. Responsabilité</h2>
      <p>Fripri est une plateforme de mise en relation entre vendeurs et acheteurs particuliers. ECOLOVALO ne saurait être tenue responsable des transactions effectuées entre utilisateurs, du contenu des annonces, ni des litiges éventuels, sauf dans les cas prévus par la loi et par nos <a href="/cgv">Conditions Générales de Vente</a>.</p>

      <h2>8. Médiation</h2>
      <p>Conformément à l’article L611-1 du Code de la consommation, en cas de litige non résolu amiablement, le consommateur peut recourir gratuitement à un médiateur de la consommation. ECOLOVALO recommande la plateforme européenne de règlement des litiges en ligne : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.</p>

      <h2>9. Droit applicable</h2>
      <p>Les présentes mentions sont soumises au droit français. Tout litige relatif au site sera de la compétence exclusive des tribunaux du ressort du siège social d’ECOLOVALO.</p>
    </LegalLayout>
  );
}
